import { render, staticRenderFns } from "./DownForMaintenance.vue?vue&type=template&id=2b59e2b5&scoped=true"
import script from "./DownForMaintenance.vue?vue&type=script&lang=js"
export * from "./DownForMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b59e2b5",
  null
  
)

export default component.exports